import React from 'react';

const ChartComponent = ({ 
  data = [], 
  height = 200,
  type = 'bar',
  color = '#ff660e'
}) => {
  if (!data.length) {
    return (
      <div className="flex items-center justify-center h-full text-gray-400">
        No data available
      </div>
    );
  }

  const maxValue = Math.max(...data.map(d => d.value));

  if (type === 'bar') {
    return (
      <div className="relative h-full">
        <div className="flex items-end justify-between h-full space-x-1">
          {data.map((item, index) => {
            const barHeight = (item.value / maxValue) * 100;
            return (
              <div key={index} className="flex flex-col items-center flex-1">
                <div 
                  className="w-full rounded-t transition-all duration-300 hover:opacity-80"
                  style={{ 
                    height: `${barHeight}%`,
                    backgroundColor: color,
                    minHeight: '4px'
                  }}
                  title={`${item.label}: ${item.value}`}
                />
                <div className="text-xs text-gray-500 mt-2 truncate w-full text-center">
                  {item.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  if (type === 'line') {
    return (
      <div className="relative h-full">
        <div className="absolute inset-0 flex items-end">
          <svg width="100%" height="100%" className="overflow-visible">
            <polyline
              fill="none"
              stroke={color}
              strokeWidth="2"
              points={data.map((item, index) => {
                const x = (index / (data.length - 1)) * 100;
                const y = 100 - (item.value / maxValue) * 100;
                return `${x}%,${y}%`;
              }).join(' ')}
            />
          </svg>
        </div>
        <div className="flex justify-between absolute bottom-0 left-0 right-0">
          {data.map((item, index) => (
            <div key={index} className="text-xs text-gray-500">
              {item.label}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return null;
};

export default ChartComponent;